var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import { UIComponent, commonPropTypes } from '../../lib';
/**
 * A layout is a utility for arranging the content of a component.
 */
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest;
        var _b = this.props, reducing = _b.reducing, disappearing = _b.disappearing, start = _b.start, main = _b.main, end = _b.end, renderStartArea = _b.renderStartArea, renderMainArea = _b.renderMainArea, renderEndArea = _b.renderEndArea, renderGap = _b.renderGap;
        var startArea = renderStartArea(__assign({}, this.props, { classes: classes }));
        var mainArea = renderMainArea(__assign({}, this.props, { classes: classes }));
        var endArea = renderEndArea(__assign({}, this.props, { classes: classes }));
        if (!startArea && !mainArea && !endArea) {
            return React.createElement(ElementType, __assign({}, rest, { className: classes.root }));
        }
        var activeAreas = [startArea, mainArea, endArea].filter(Boolean);
        var isSingleArea = activeAreas.length === 1;
        // disappear: render the content directly without wrapping layout or area elements
        if (disappearing && isSingleArea) {
            return start || main || end;
        }
        if (reducing && isSingleArea) {
            var composedClasses = cx(classes.root, startArea && 'ui-layout--reduced__start', mainArea && 'ui-layout--reduced__main', endArea && 'ui-layout--reduced__end');
            return (React.createElement(ElementType, __assign({}, rest, { className: composedClasses }), start || main || end));
        }
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }),
            startArea,
            startArea && mainArea && renderGap(__assign({}, this.props, { classes: classes })),
            mainArea,
            (startArea || mainArea) && endArea && renderGap(__assign({}, this.props, { classes: classes })),
            endArea));
    };
    Layout.className = 'ui-layout';
    Layout.displayName = 'Layout';
    Layout.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { debug: PropTypes.bool, renderStartArea: PropTypes.func, renderMainArea: PropTypes.func, renderEndArea: PropTypes.func, renderGap: PropTypes.func, rootCSS: PropTypes.object, start: PropTypes.any, startCSS: PropTypes.object, startSize: PropTypes.string, main: PropTypes.any, mainCSS: PropTypes.object, mainSize: PropTypes.string, end: PropTypes.any, endCSS: PropTypes.object, endSize: PropTypes.string, justifyItems: PropTypes.any, alignItems: PropTypes.any, gap: PropTypes.string, reducing: PropTypes.bool, disappearing: PropTypes.bool, truncateStart: PropTypes.bool, truncateMain: PropTypes.bool, truncateEnd: PropTypes.bool, vertical: PropTypes.bool });
    Layout.defaultProps = {
        startSize: 'auto',
        mainSize: '1fr',
        endSize: 'auto',
        // TODO: when an area is another Layout, do not wrap them in an extra div
        // TODO: option 1) higher value layouts could use start={Layout.create(start)} to ensure Areas are layout root
        renderStartArea: function (_a) {
            var start = _a.start, classes = _a.classes;
            return start && React.createElement("div", { className: cx('ui-layout__start', classes.start) }, start);
        },
        renderMainArea: function (_a) {
            var main = _a.main, classes = _a.classes;
            return main && React.createElement("div", { className: cx('ui-layout__main', classes.main) }, main);
        },
        renderEndArea: function (_a) {
            var end = _a.end, classes = _a.classes;
            return end && React.createElement("div", { className: cx('ui-layout__end', classes.end) }, end);
        },
        // Heads up!
        // IE11 Doesn't support grid-gap, insert virtual columns instead
        renderGap: function (_a) {
            var gap = _a.gap, classes = _a.classes;
            return gap && React.createElement("span", { className: cx('ui-layout__gap', classes.gap) });
        },
    };
    return Layout;
}(UIComponent));
export default Layout;
